import {
	Attach20Regular,
	ChevronDownRegular,
	ArrowDownload20Regular,
	Image20Regular,
	Document20Regular,
} from "@fluentui/react-icons";
import { Text, mergeClasses } from "@fluentui/react-components";
import { Flex, GapSize } from "../flex";
import { PopoverView } from "../popover";
import { AttachmentListProps, AttachmentItemProps } from "./types";
import { useListStyle } from "./style";
import { useCallback, MouseEvent } from "react";
import { fromBytesToImageSrc, isImage } from "@/common/helpers";
import { FilePreview } from "@/components/molecules/filePreview";
import {
	fetchAttachment,
	fetchHistoryMessageAttachment,
} from "@/repository/queryFns";

export const AttachmentList = (props: AttachmentListProps) => {
	const { sessionId, isHistory, items, isPreview } = props;
	const classes = useListStyle();

	const attachmentIcon = useCallback(
		(contentType: string) =>
			isImage(contentType) ? <Image20Regular /> : <Document20Regular />,
		[]
	);

	const fetchAttachmentPromise = useCallback(
		async (x: AttachmentItemProps) => {
			let attachment;

			if (isHistory) {
				attachment = await fetchHistoryMessageAttachment(
					sessionId,
					x.messageId,
					x.id
				);
			} else {
				attachment = await fetchAttachment(
					sessionId,
					isPreview,
					x.messageId,
					x.id
				);
			}

			return fromBytesToImageSrc(
				attachment.contentType,
				attachment.contentBytes
			);
		},
		[isHistory, sessionId, isPreview]
	);

	return (
		<PopoverView
			positioning={{ position: "below", align: "end" }}
			classes={{ trigger: classes.popoverTrigger }}
			trigger={
				<Flex vAlign="center" gap={GapSize.ExtraSmall}>
					<Attach20Regular />
					<Text children={items.length} />
					<ChevronDownRegular />
				</Flex>
			}
			content={
				<Flex column className={classes.root}>
					{items.map((x: AttachmentItemProps) => (
						<Flex key={x.id} className={classes.container}>
							<FilePreview
								queryKey={x.id}
								queryFn={() => {
									return fetchAttachmentPromise(x);
								}}
								name={x.name}
								children={(preview: () => void, download: () => void) => (
									<div>
										<button
											className={mergeClasses(
												classes.button,
												classes.primaryButton
											)}
											onClick={(e: MouseEvent<HTMLButtonElement>) => {
												e.preventDefault();
												(isImage(x.contentType) ? preview : download)();
											}}
											children={
												<Flex vAlign="center" gap={GapSize.Small}>
													<div>{attachmentIcon(x.contentType)}</div>
													<Flex column className={classes.midContainer}>
														<Text
															size={200}
															truncate
															wrap={false}
															title={x.name}
															children={x.name}
														/>
														<Text size={100} children={x.date} />
													</Flex>
												</Flex>
											}
										/>
										<button
											className={classes.button}
											onClick={(e: MouseEvent<HTMLButtonElement>) => {
												e.preventDefault();
												download();
											}}
											children={<ArrowDownload20Regular />}
										/>
									</div>
								)}
							/>
						</Flex>
					))}
				</Flex>
			}
		/>
	);
};
